"use client";

import { NumericProgress } from "@/components/ui/progress/NumericProgress";
import { ProgressBar } from "@/components/ui/progress/ProgressBar";
import { ProgressStatus } from "@/components/ui/progress/ProgressStatus";
import { IsolationConstructedNoDates } from "@/types/types";

export function NotDoneIsolation({
  isolation,
}: {
  isolation: IsolationConstructedNoDates;
}) {
  const percentageDone = isolation.percentageDone;
  const hasProgress = isolation.percentageDone > 10;
  return (
    <div className="flex h-full flex-col justify-between">
      <div className="flex flex-row items-center">
        <ProgressBar progress={percentageDone} />
        <NumericProgress progress={percentageDone} />
      </div>
      <div className="mt-4">
        <ProgressStatus processType={hasProgress ? "Isolating" : "Starting"} />
      </div>
    </div>
  );
}
